import {TypeLang} from '@/store/language/language';
import request from "./request";

type TPush = 'friend' | 'chat' | 'groupchat'
const WEB_DEVICE_TYPE = 3

export const pushApp = (id: string, type: TPush) => {
  let formData = {}
  if (type === 'chat') {
    formData = {
      memberId: id.split('@')[0],
      type: type,
    }
  } else if (type === 'groupchat') {
    formData = {
      chatId: id.split('@')[0],
      type: type,
    }
  } else if (type === 'friend') {
    formData = {
      memberId: id.split('@')[0],
      type: type,
    }
  }
  return request('get', '/api/user/push-notify', formData)
    .then(data => {
      return data.data
    })
}

export const pushCall = (memberId: string) => {
  return request('get', '/api/user/push-call', {
    called: memberId
  })
}

export interface ChangeTokenProps {
  token: string,
  lang: TypeLang
}
export const addToken = async(props: ChangeTokenProps): Promise<void> => {
  await request(
    'get',
    'api/users/add-token',
    {
      ...props,
      deviceType: WEB_DEVICE_TYPE,
      device_name: window.navigator.userAgent,
      os_version: 'web'
    }
  )
}

export const changeLang = async(props: ChangeTokenProps): Promise<void> => {
  await request(
    'get',
    'api/users/update/lang',
    props
  )
}

export const removeToken = async(token: string): Promise<void> => {
  await request(
    'get',
    'api/users/remove-token', {
      deviceType: WEB_DEVICE_TYPE,
      token
    }
  )
}
